module.exports = __webpack_public_path__ + "static/media/CSSW-15805-Star-Certificate__my_portfolio_25-11-2021.c2db87ec.pdf";